export default "__VITE_ASSET__BdIxPP2N__"